import React, { useEffect, useState } from "react";
import Helmet from "../components/Helmet";
import HeroSlider from "../components/HeroSlider";
import { Container, Row, Col } from "reactstrap";
import FindCarForm from "../components/FindCarForm";

import HotOffer from "../components/HotOffer";
import Testimonial from "../components/Testimonial";

import ServicesItem from "../components/TripsItem";
import BlogList from "../components/BlogList";

import BecomeDriver from "../components/BecomeDriver";

import AboutSection from "../components/AboutSection";
import TrendingBrand from "../components/TrendingBrand";
import jwtDecode from "jwt-decode";
import OurMember from "../components/OurMember";
import GetApp from "../components/GetApp";
import HisoDesign from "../assets/img/HisoDesign.png";

const Home = () => {
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token != null) {
      const decoded = jwtDecode(token);
      console.log(typeof decoded.roles);
      setUser(decoded);

      setToken(token);
    }
  }, []);

  const [token, setToken] = useState("");
  const [user, setUser] = useState(null);
  return (
    <Helmet title="Home">
      <section className="p-0 hero__slider__section">
        <HeroSlider />
      </section>
      {/* <section className="about__section">
        <Container>
          <AboutSection />
        </Container>
      </section> */}

      <section>
        <Container>
          <Row>
            <Col lg="12" className="text-center mb-5">
              <h6 className="section__subtitle">See Our</h6>
              <h2 className="section__title">Trending Brands</h2>
            </Col>

            <TrendingBrand />
          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row>
            <Col lg="12 text-center mb-5">
              <h6 className="section__subtitle">Come With</h6>
              <h2 className="section__title">Hot Offers</h2>
            </Col>

            <HotOffer />
          </Row>
        </Container>
      </section>
      {user == null || typeof user.roles ? null : (
        <section className="become__driver">
          <Container>
            <BecomeDriver />
          </Container>
        </section>
      )}
      <section>
        <Container>
          <Row>
            {/* <Col lg="12 text-center mb-5">
              <h6 className="section__subtitle">Check out our</h6>
              <h2 className="section__title">App</h2>
            </Col> */}
            <GetApp />
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <img src={HisoDesign} />
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <Col lg="12 text-center mb-5">
              <h6 className="section__subtitle">Our Top Rated</h6>
              <h2 className="section__title">Hosts</h2>
            </Col>

            <OurMember />
          </Row>
        </Container>
      </section>
      <section>
        <Container>
          <Row>
            <Col lg="12 text-center mb-5">
              <h6 className="section__subtitle">Our Clients Says</h6>
              <h2 className="section__title">Testimonial</h2>
            </Col>
            <Testimonial />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Home;
